export default {
  en: {
    subtitle: 'List of links associated with integrations',
    form: {
      referrer: {
        hint: 'Link associated with integration',
      }
    },
    success: {
      patch: 'The link was patched correctly',
      create: 'The link was created',
    }
  },
  es: {
    subtitle: 'Lista de enlaces asociados con integraciones',
    form: {
      referrer: {
        hint: 'Enlace asociado a la integración',
      }
    },
    success: {
      patch: 'El enlace ha sido editado correctamente',
      create: 'El enlace ha sido creado correctamente',
    }
  },
  fr: {
    subtitle: 'Liste des liens associés aux intégrations',
    form: {
      referrer: {
        hint: 'Lien associé à l\'intégration',
      }
    },
    success: {
      patch: 'Le lien a été modifié avec succès',
      create: 'Le lien a été créé avec succès',
    }
  }

}
